import { useIsStoreInMobileOrderDriveThruStores } from 'features/store/hooks/use-is-store-in-mobile-order-drive-thru-stores';

import { Nullable } from '@rbi-ctg/frontend';
import { ServiceMode } from 'generated/graphql-gateway';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

export const useIsMobileOrderForDriveThru = (
  serviceMode: Nullable<ServiceMode>,
  storeNumber?: string | null
): boolean => {
  const isMobileOrderForDriveThruLaneEnabled = useFlag(
    LaunchDarklyFlag.ENABLE_MOBILE_ORDER_DRIVE_THRU_LANE
  );
  const isMobileOrderDriveThruEnabledForStore = useIsStoreInMobileOrderDriveThruStores(storeNumber);

  return (
    (serviceMode === ServiceMode.MOBILE_ORDER_DRIVE_THRU &&
      isMobileOrderDriveThruEnabledForStore) ||
    (serviceMode === ServiceMode.DRIVE_THRU && isMobileOrderForDriveThruLaneEnabled)
  );
};
